import React, { useState } from 'react';
import BaseModal from 'flow/components/ui-components/BaseModal';
import Checkbox from 'flow/components/ui-components/Checkbox';
import useAppContext from 'flow/hooks/useAppContext';
import { saveOpenInAppPreference } from 'flow/utils/meeting-utils';

interface Props {
    onConfirm?: () => void;
    onCancel?: () => void;
}

const MeetingLobbyOpenInAppDialog: React.FC<Props> = ({
    onConfirm,
    onCancel,
}) => {
    const { i18next } = useAppContext();
    const [rememberDecision, setRememberDecision] = useState(false);

    const handleConfirm = () => {
        if (rememberDecision) {
            saveOpenInAppPreference(true);
        }
        onConfirm?.();
    };

    const handleCancel = () => {
        if (rememberDecision) {
            saveOpenInAppPreference(false);
        }
        onCancel?.();
    };

    const handleCheckboxChange = (
        _event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean,
    ) => {
        setRememberDecision(checked);
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('videoconference.lobby.open_in_app_modal.title')}
            onSubmit={handleConfirm}
            onClose={handleCancel}
            confirmButtonText={i18next.t('app.confirm')}
            className="w-[400px]"
        >
            <div className="space-y-4">
                <p className="text-sm text-gray-700">
                    {i18next.t(
                        'videoconference.lobby.open_in_app_modal.description',
                    )}
                </p>

                <Checkbox
                    label={i18next.t(
                        'videoconference.lobby.open_in_app_modal.remember',
                    )}
                    checked={rememberDecision}
                    onChange={handleCheckboxChange}
                />
            </div>
        </BaseModal>
    );
};

export default MeetingLobbyOpenInAppDialog;
